import { create } from 'zustand';
import { DataSnapshot, HistoricalIndex } from '@bedrock-profiles/shared';

interface DataState {
  // Current data (managed by TanStack Query)
  currentSnapshot?: DataSnapshot;
  setCurrentSnapshot: (snapshot?: DataSnapshot) => void;

  // Historical data (managed by TanStack Query)
  historicalIndex?: HistoricalIndex;
  setHistoricalIndex: (index?: HistoricalIndex) => void;

  // Selected version (UI state only)
  selectedVersion: string;
  setSelectedVersion: (version: string) => void;
}

export const useDataStore = create<DataState>((set) => ({
  currentSnapshot: undefined,
  setCurrentSnapshot: (snapshot) => set({ currentSnapshot: snapshot }),

  historicalIndex: undefined,
  setHistoricalIndex: (index) => set({ historicalIndex: index }),

  selectedVersion: 'latest',
  setSelectedVersion: (version) => set({ selectedVersion: version }),
}));
